import './App.css';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MessageDialogProvider from './components/auth/MessageDialogProvider';
import { themeSettings } from './theme/theme';
import LoginPage from './pages/LoginPage';
import VerifyOtpPage from './pages/VerifyOtpPage';
import VerifyTokenPage from './pages/VerifyTokenPage';
import BazzarPage from './pages/BazzarPage';
import MyRewardPage from './pages/MyRewardPage';
import MyRewardDetailPage from './pages/MyRewardDetailPage';
import RapchikRewardDetailPage from './pages/RapchikRewardDetailPage';
import TransactionsPage from './pages/TransactionsPage';
import ReferralsPage from './pages/ReferralsPage';
import MyProfilePage from './pages/MyProfilePage';
import MyWalletPage from './pages/MyWalletPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PrivateRoute from './routes/PrivateRoute';
import {
  BAZZAR_MOBILE_PATH,
  BAZZAR_PATH,
  MY_PROFILE_PATH,
  MY_REWARD_PATH,
  MY_WALLET_PATH,
  REFERRALS_PATH,
  TRANSACTIONS_PATH,
  TERMS_PATH,
  PRIVACY_PATH,
} from './routes/paths';

function App() {
  const mode = useSelector((state) => state.global.mode);

  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <MessageDialogProvider>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/verify" element={<VerifyOtpPage />} />
            <Route path="/verify-token" element={<VerifyTokenPage />} />
            <Route path={TERMS_PATH} element={<TermsConditionsPage />} />
            <Route path={PRIVACY_PATH} element={<PrivacyPolicyPage />} />
            <Route
              path={BAZZAR_PATH}
              element={
                <PrivateRoute>
                  <BazzarPage />
                </PrivateRoute>
              }
            />
            <Route
              path={BAZZAR_MOBILE_PATH}
              element={
                <PrivateRoute>
                  <BazzarPage />
                </PrivateRoute>
              }
            />
            <Route
              path={TRANSACTIONS_PATH}
              element={
                <PrivateRoute>
                  <TransactionsPage />
                </PrivateRoute>
              }
            />
            <Route
              path={REFERRALS_PATH}
              element={
                <PrivateRoute>
                  <ReferralsPage />
                </PrivateRoute>
              }
            />
            <Route
              path={MY_PROFILE_PATH}
              element={
                <PrivateRoute>
                  <MyProfilePage />
                </PrivateRoute>
              }
            />
            <Route
              path={MY_WALLET_PATH}
              element={
                <PrivateRoute>
                  <MyWalletPage />
                </PrivateRoute>
              }
            />
            <Route
              path={MY_REWARD_PATH}
              element={
                <PrivateRoute>
                  <MyRewardPage />
                </PrivateRoute>
              }
            />
            <Route
              path={`${MY_REWARD_PATH}/prize/:id`}
              element={
                <PrivateRoute>
                  <RapchikRewardDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path={`${MY_REWARD_PATH}/:id`}
              element={
                <PrivateRoute>
                  <MyRewardDetailPage />
                </PrivateRoute>
              }
            />
          </Routes>
          </MessageDialogProvider>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
          />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
